import { Language } from './base';

const pdash = () => import('../translations/pdash/zh-Hans.json');
const webActivities = () => import('../translations/web-activities/zh-Hans.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/zh-Hans.json');

export default new Language({
    code: 'zh-Hans',
    locale: 'zh',
    localName: '汉语',
    englishName: 'Simplified Chinese',
    territory: 'Hans',
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
